import { useState, useEffect } from "react";
import { FaTrash, FaPlus, FaEdit } from "react-icons/fa";
import { toast } from "react-toastify";
import InputProductos from "./Inputs/InputProductos";
import PlantillaModal from "./PlantillaModal";
import TablaProducto from "./tablas/TablaProducto";
import { useContextoSesion } from "../../miscelaneo/ContextoSesion"; // Importa el hook del contexto
import FuncionesGenerales from "./FuncionesGenerales";
import TablaRetencion from "./tablas/TablaRetencion";
import InputRetencion from "./Inputs/InputRetencion";
import InputCompras from "./Inputs/InputCompras";
import ValidacionesCampos from "./ValidacionesCampos";
const TablaDinamica = ({
  fields = [],
  onChange,
  value,
  onPaisChange,
  onProvinciaChange,
  valoresPrevios,
  camposRequeridos = [],
  editable = true,
  nombresProductos = [],
  setNombresProductos = () => {},
  tipo_producto = [],
  modificarCosto = false,
  tipo_tabla_producto = "normal",
  id_sucursal_tabla_producto = 0,
  retenciones = {},
  nombresRetenciones = [],
  setNombresRetenciones = () => {},
  retencion_itbis = 0,
  retencion_monto = 0,
  contieneInputRetencion = false,
  formData = {},
  modoTablaDinamica = "normal",
  AgregarSinModificar = false,
  totalFactura = 0,
  formatoMoneda = (x) => x,
}) => {
  const { usuario } = useContextoSesion();
  const { formatoMoneda: formatoMonedaLocal, formatearFechaInput } =
    FuncionesGenerales(usuario);

  const [mostrarModalProducto, setMostrarModalProducto] = useState(false);
  const [mostrarModalRetencion, setMostrarModalRetencion] = useState(false);

  function handleSeleccionarRetencion(id_retencion) {
    handleInputChange(id_retencion, "id_retencion");
  }

  function handleSeleccionarProducto(id_producto) {
    handleInputChange(id_producto, "id_producto");
  }
  // console.log("FIELDS recibidos en TablaDinamica:", fields);
  // console.log("Provincias (en fields):", fields.find(f => f.name === "id_provincia")?.options);
  useEffect(() => {
    setRows(value || []);
  }, [value]);

  useEffect(() => {
    setCurrentRow({});
  }, [id_sucursal_tabla_producto]);
  const [currentRow, setCurrentRow] = useState({});

  useEffect(() => {
    if (modoTablaDinamica == "NotaCreditoProveedor") {
      setCurrentRow({
        id_compra: "",
        monto: 0,
        balance_actual: 0,
        fecha_aplicacion: formatearFechaInput(new Date()),
      });
    }
  }, [formData?.id_entidad_proveedor]);
  // useEffect(() => {
  //   console.log('Nombres Retenciones',currentRow)
  // }, [currentRow]);

  const [rows, setRows] = useState([]);

  // useEffect(() => {
  //   console.log('rows',rows)
  // }, [rows]);

  const [editIndex, setEditIndex] = useState(null);

  const handleInputChange = (e, name) => {
    if (!editable && !AgregarSinModificar) {
      return;
    }
    let newRow;
    if (name == "id_compra" && modoTablaDinamica == "NotaCreditoProveedor") {
      // console.log('compra',e)
      newRow = {
        ...currentRow,
        [name]: e.id_compra,
        ["balance_actual"]: e.balance,
      };
      setCurrentRow(newRow);
    } else if (name == "id_retencion") {
      // console.log('retencion',e)
      newRow = { ...currentRow, [name]: e[0] };
      setMostrarModalRetencion(false);
      setNombresRetenciones((prev) => [...prev, { value: e[0], label: e[1] }]);

      let monto = 0;
      if (e[3] == "1") {
        monto = (Number(retencion_monto) * Number(e[2])).toFixed(2);
      } else if (e[3] == "2") {
        monto = (Number(retencion_itbis) * Number(e[2])).toFixed(2);
      }
      newRow.monto = monto;
    } else if (name == "id_producto") {
      newRow = { ...currentRow, [name]: e[0] };
      if (modificarCosto) {
        newRow.costo = e[2];
        // Aquí asignas directamente
      }

      if (
        modoTablaDinamica == "AjusteInventario" ||
        modoTablaDinamica == "TransferenciaInventario"
      ) {
        const existenciaActual = Number(e[3]);
        newRow.cantidad = 0;
        newRow.existencia_actual = existenciaActual;
      }
      setMostrarModalProducto(false);
      setNombresProductos((prev) => [...prev, { value: e[0], label: e[1] }]);
    } else {
      newRow = { ...currentRow, [name]: e.target.value };
    }

    if (
      modoTablaDinamica == "TransferenciaInventario" ||
      modoTablaDinamica == "AjusteInventario"
    ) {
      const cantidad = Number(newRow.cantidad);
      if (cantidad < 0) {
        toast.error("La cantidad no puede ser negativa.");
        newRow.cantidad = 0;
        return;
      }
    }

    if (modoTablaDinamica == "TransferenciaInventario") {
      const cantidad = Number(newRow.cantidad);
      if (cantidad > newRow.existencia_actual) {
        toast.error(
          "La cantidad a transferir no puede ser mayor a la existencia en la sucursal de origen",
        );
        newRow.cantidad = 0;

        return;
      }
    }
    if (modoTablaDinamica == "AjusteInventario") {
      const cantidadajuste = Number(newRow.cantidad);

      if (newRow.costo < 0) {
        toast.error("El costo no puede ser negativo.");
        newRow.costo = 0;
        return;
      }
      const existenciaActual = currentRow.existencia_actual;

      if (newRow.incrementar === "false" && existenciaActual < cantidadajuste) {
        toast.error(
          "No se puede disminuir una cantidad mayor a la existencia actual. ",
        );
        return;
      }
      //   newRow.existencia_actual = existenciaActual;

      if (newRow.incrementar === "true") {
        newRow.existencia_final = existenciaActual + cantidadajuste;
      } else if (newRow.incrementar === "false") {
        newRow.existencia_final = existenciaActual - cantidadajuste;
      } else {
        newRow.existencia_final = existenciaActual;
      }
    }

    setCurrentRow(newRow);

    if (name === "id_pais" && onPaisChange) {
      onPaisChange(e.target.value);
      setCurrentRow((prevRow) => ({
        ...prevRow,
        id_provincia: "", // Resetear provincia cuando cambia país
        id_municipio: "", // También puedes resetear municipio si aplica
      }));
    }
    if (name === "id_provincia" && onProvinciaChange) {
      onProvinciaChange(e.target.value);
    }
  };

  const handleAddOrUpdateRow = () => {
    // console.log(editable)

    if (!editable && !AgregarSinModificar) {
      return;
    }

    if (contieneInputRetencion) {
      if (Number(currentRow.monto) <= 0) {
        toast.error("El monto debe ser mayor a 0");
        return;
      }
    }

    // Validación específica para pagos de factura
    if (modoTablaDinamica == "PagoFactura") {
      const montoIngresado = parseFloat(currentRow.monto) || 0;
      if (montoIngresado <= 0) {
        toast.error("El monto debe ser mayor a 0");
        return;
      }

      const otrosPagos = rows
        .filter((_, index) => index !== editIndex)
        .reduce((sum, pago) => sum + (parseFloat(pago.monto) || 0), 0);
      const totalPagos = montoIngresado + otrosPagos;

      if (totalPagos > totalFactura) {
        const maximoDisponible = totalFactura - otrosPagos;
        toast.error(
          `El monto ${formatoMoneda(montoIngresado)} excedería el total de la factura. Máximo disponible: ${formatoMoneda(maximoDisponible)}`,
        );
        return;
      }
    }

    if (modoTablaDinamica == "NotaCreditoProveedor") {
      //console.log('NotaCreditoProveedor',currentRow)
      if (Number(currentRow.balance_actual) < Number(currentRow.monto)) {
        toast.error(
          "El monto no puede ser mayor al balance actual de la compra, el balance actual es: " +
            formatoMoneda(currentRow.balance_actual),
        );
        return;
      }
      if (Number(formData?.monto_total || 0) < Number(currentRow.monto)) {
        toast.error(
          "El monto no puede ser mayor al monto total de la nota de credito, el monto total es: " +
            formatoMoneda(formData?.monto_total),
        );
        return;
      }
      if (
        Number(rows.reduce((acc, row) => acc + (Number(row.monto) || 0), 0)) +
          Number(currentRow.monto) >
        Number(formData?.monto_total || 0)
      ) {
        toast.error(
          "El monto total de las aplicaciones de nota de credito no puede ser mayor al monto total de la nota de crédito",
        );
        return;
      }
    }
    if (modoTablaDinamica == "SecuenciaComprobante") {
      if (
        currentRow.contador < 0 ||
        currentRow.fin < 0 ||
        currentRow.alerta < 0
      ) {
        toast.error(
          "El contador, fin y alerta no deben contener valores negativos",
        );
        return;
      }

      if (currentRow.fin < 1) {
        toast.error("El fin debe ser mínimo 1");
        return;
      }
      if (Number(currentRow.contador) > Number(currentRow.fin)) {
        // console.log(currentRow)
        toast.error("El contador debe ser menor a el fin");
        return;
      }

      if (currentRow.fecha_vencimiento) {
        const hoy = new Date();
        const vencimiento = new Date(currentRow.fecha_vencimiento);
        hoy.setHours(0, 0, 0, 0);
        vencimiento.setHours(0, 0, 0, 0);
        if (vencimiento < hoy) {
          toast.error("La fecha de vencimiento debe ser como mínimo mañana.");
          return;
        }
      }
      if (currentRow.preferida === "true") {
        const indexFound = rows.findIndex(
          (row, index) =>
            row.id_tipo_comprobante_fiscal ===
              currentRow.id_tipo_comprobante_fiscal &&
            row.preferida === "true" && // <-- Aquí también se ajusta
            index !== editIndex,
        );

        if (indexFound !== -1) {
          toast.error(
            "Ya existe una secuencia marcada como preferida para este tipo de comprobante.",
          );
          return;
        }
      }
    }
    if (modoTablaDinamica == "AjusteInventario") {
      if (currentRow.cantidad <= 0) {
        toast.error("La cantidad de ajuste debe ser mayor que 0");
        return;
      }
    }
    if (modoTablaDinamica == "TransferenciaInventario") {
      if (!currentRow.cantidad || currentRow.cantidad <= 0) {
        toast.error("La cantidad a transferir debe ser mayor a 0");
        return;
      }
      if (currentRow.existencia_actual !== undefined && currentRow.existencia_actual !== null) {
        if (currentRow.cantidad > currentRow.existencia_actual) {
          toast.error("La cantidad a transferir no puede ser mayor a la existencia en la sucursal de origen");
          return;
        }
        if (currentRow.existencia_actual === 0) {
          toast.error("No se puede transferir un producto sin existencia en la sucursal de origen");
          return;
        }
      }
    }
    const camposVacios = camposRequeridos.filter(
      (campo) => currentRow[campo] === "" || currentRow[campo] === undefined,
    );

    if (camposVacios.length > 0) {
      toast.error("Por favor completa los campos obligatorios.");
      return;
    }

    // Validar formatos según el tipo de campo
    for (const field of fields) {
      const valor = currentRow[field.name];

      // Skip si está vacío y no es requerido
      if (!valor && !camposRequeridos.includes(field.name)) {
        continue;
      }

      // Validar según el tipo
      if (
        field.type === "email" &&
        valor &&
        !ValidacionesCampos.esEmailValido(valor)
      ) {
        toast.error(`El formato del ${field.label || field.name} no es válido`);
        return;
      }

      if (
        field.type === "tel" &&
        valor &&
        !ValidacionesCampos.esTelefonoValido(valor)
      ) {
        toast.error(`El formato del ${field.label || field.name} no es válido`);
        return;
      }

      if (
        field.type === "number" &&
        valor &&
        !ValidacionesCampos.esNumeroNoNegativo(valor)
      ) {
        toast.error(`${field.label || field.name} no puede ser negativo`);
        return;
      }

      // Validación específica para número de cuenta bancaria
      if (
        field.name === "numero_cuenta" &&
        valor &&
        !ValidacionesCampos.esCuentaBancariaValida(valor)
      ) {
        toast.error("El número de cuenta debe tener al menos 10 dígitos");
        return;
      }
    }

    if (Object.values(currentRow).some((v) => v === "" || v === undefined))
      return;

    for (const field of fields) {
      if (field.unico) {
        const indexFound = rows.findIndex(
          (row, index) =>
            row[field.name] == currentRow[field.name] && index != editIndex,
        );

        if (indexFound !== -1) {
          toast.error(
            `No puede repetir el valor para ${field.label || field.name}, actualice el registro existente si desea realizar cambios.`,
          );
          return;
        }
      }
    }

    const newRow = AgregarSinModificar
      ? { ...currentRow, AgregarSinModificar: true }
      : { ...currentRow };

    const updatedRows = [...rows];
    if (editIndex !== null) {
      updatedRows[editIndex] = newRow;
      setEditIndex(null); // Reseteamos el índice de edición
    } else {
      //Si no, seria agregar una nueva fila
      updatedRows.push(newRow);
    }

    setRows(updatedRows);

    // Ahora pasamos tanto las filas como el currentRow al padre
    onChange(updatedRows);
    if (onPaisChange) {
      onPaisChange(9999);
    } // Esto permite que el padre acceda a currentRow
    if (onProvinciaChange) {
      onProvinciaChange(9999);
    }

    setCurrentRow({});
  };

  const handleRemoveRow = (index) => {
    if (!editable) {
      return;
    }
    const updated = rows.filter((_, i) => i !== index);
    setRows(updated);
    onChange(updated);
  };

  const handleEditRow = (index) => {
    if (!editable && !AgregarSinModificar) {
      return;
    }
    setCurrentRow(rows[index]); // Cargamos los datos de la fila en los inputs
    setEditIndex(index); // Establecemos el índice para saber que estamos editando
  };

  return (
    <div className="">
      {(editable || AgregarSinModificar) && (
        <>
          {/* Inputs con labels */}
          <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(230px,_1fr))]">
            {fields.map(
              ({
                name,
                placeholder,
                type,
                label,
                options,
                funcion = () => {},
                disabled = false,
              }) => {
                // Caso de select (sin cambios)
                if (type === "select" && Array.isArray(options)) {
                  let selectOptions = options;
                  if (name === "id_provincia" && valoresPrevios?.provincias) {
                    selectOptions = [
                      ...new Map(
                        [...options, ...valoresPrevios.provincias].map(
                          (option) => [option.value, option],
                        ),
                      ).values(),
                    ];
                  }
                  if (name === "id_municipio" && valoresPrevios?.municipios) {
                    selectOptions = [
                      ...new Map(
                        [...options, ...valoresPrevios.municipios].map(
                          (option) => [option.value, option],
                        ),
                      ).values(),
                    ];
                  }
                  return (
                    <div key={name} className="flex flex-col">
                      <label
                        htmlFor={name}
                        className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                      >
                        {label || placeholder || name}
                        {camposRequeridos.includes(name) && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <select
                        id={name}
                        name={name}
                        value={currentRow[name] ? String(currentRow[name]) : ""}
                        onChange={(e) => handleInputChange(e, name)}
                        className={`p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                          camposRequeridos.includes(name) &&
                          (editable || AgregarSinModificar)
                            ? "border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                            : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                        }`}
                        disabled={!editable && !AgregarSinModificar}
                      >
                        <option value="">Selecciona una opción</option>
                        {selectOptions.map((opt) => (
                          <option key={opt.value} value={String(opt.value)}>
                            {opt.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  );

                  // Caso para el nuevo type "producto"
                } else if (type === "producto") {
                  return (
                    <div key={name} className="flex flex-col">
                      <label
                        htmlFor={name}
                        className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                      >
                        {label || placeholder || name}
                        {camposRequeridos.includes(name) && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <InputProductos
                        valor={currentRow[name] || ""}
                        onClick={
                          () => setMostrarModalProducto(true)

                          /* Aquí puedes ejecutar la acción correspondiente al hacer clic.
               Por ejemplo, podría invocar una función de búsqueda o actualizar el estado.
               Si lo prefieres, puedes definir una función dedicada, ej. handleProductoClick(name, valor) */
                          // handleInputChange({ target: { value: valor } }, name);
                        }
                        placeholder={placeholder || "Buscar producto..."}
                        nombreProducto={
                          nombresProductos.find(
                            (opt) =>
                              String(opt.value) === String(currentRow[name]),
                          )?.label ||
                          currentRow[name] ||
                          ""
                        }
                        onChange={(e) => handleInputChange(e, name)}
                        editable={editable || AgregarSinModificar}
                        esRequerido={camposRequeridos.includes(name)}
                      />
                    </div>
                  );

                  // Caso general (input por defecto)
                } else if (type === "compra") {
                  return (
                    <div key={name} className="flex flex-col">
                      <label
                        htmlFor={name}
                        className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                      >
                        {label || placeholder || name}
                        {camposRequeridos.includes(name) && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <InputCompras
                        modo={modoTablaDinamica ? modoTablaDinamica : "normal"}
                        id_entidad_proveedor={
                          formData?.id_entidad_proveedor || null
                        }
                        // valor={currentRow[name] || ""}

                        // onClick={() => setMostrarModalProducto(true)

                        //   /* Aquí puedes ejecutar la acción correspondiente al hacer clic.
                        //      Por ejemplo, podría invocar una función de búsqueda o actualizar el estado.
                        //      Si lo prefieres, puedes definir una función dedicada, ej. handleProductoClick(name, valor) */
                        //  // handleInputChange({ target: { value: valor } }, name);
                        // }
                        placeholder={
                          currentRow?.id_compra ||
                          placeholder ||
                          "Buscar compra..."
                        }
                        // nombreProducto={ (nombresProductos.find(
                        //   opt => String(opt.value) === String(currentRow[name]))?.label) ||   currentRow[name] || ""}
                        handleChange={(e) => handleInputChange(e, name)}
                        editable={editable || AgregarSinModificar}
                        esRequerido={camposRequeridos.includes(name)}
                      />
                    </div>
                  );
                } else if (type === "retencion") {
                  return (
                    <div key={name} className="flex flex-col">
                      <label
                        htmlFor={name}
                        className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                      >
                        {label || placeholder || name}
                        {camposRequeridos.includes(name) && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <InputRetencion
                        valor={currentRow[name] || ""}
                        onClick={
                          () => setMostrarModalRetencion(true)

                          /* Aquí puedes ejecutar la acción correspondiente al hacer clic.
               Por ejemplo, podría invocar una función de búsqueda o actualizar el estado.
               Si lo prefieres, puedes definir una función dedicada, ej. handleProductoClick(name, valor) */
                          // handleInputChange({ target: { value: valor } }, name);
                        }
                        placeholder={placeholder || "Buscar retencion..."}
                        nombreRetencion={
                          nombresRetenciones.find(
                            (opt) =>
                              String(opt.value) === String(currentRow[name]),
                          )?.label ||
                          currentRow[name] ||
                          ""
                        }
                        onChange={(e) => handleInputChange(e, name)}
                        editable={editable || AgregarSinModificar}
                        esRequerido={camposRequeridos.includes(name)}
                      />
                    </div>
                  );

                  // Caso general (input por defecto)
                } else {
                  return (
                    <div key={name} className="flex flex-col">
                      <label
                        htmlFor={name}
                        className="text-sm font-semibold text-gray-700 flex items-center gap-1"
                      >
                        {label || placeholder || name}
                        {camposRequeridos.includes(name) && (
                          <span className="text-red-500">*</span>
                        )}
                      </label>
                      <input
                        type={type || "text"}
                        id={name}
                        name={name}
                        placeholder={placeholder || name}
                        value={currentRow[name] || ""}
                        onChange={(e) => handleInputChange(e, name)}
                        className={`p-2 rounded-xl text-gray-700 border-2 outline-none transition-all ${
                          camposRequeridos.includes(name) &&
                          (editable || AgregarSinModificar)
                            ? "border-red-200 focus:border-red-500 focus:ring-2 focus:ring-red-100"
                            : "border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-100"
                        }`}
                        disabled={
                          (!editable && !AgregarSinModificar) || disabled
                        }
                      />
                    </div>
                  );
                }
              },
            )}
          </div>

          {/* Botón agregar o actualizar debajo de los inputs */}
          <div className="flex justify-center mt-2">
            <button
              type="button"
              onClick={handleAddOrUpdateRow}
              disabled={!editable && !AgregarSinModificar}
              className="bg-color-secundario mt-3 mb-3 text-white rounded-xl px-4 py-2 hover:bg-color-secundario/90 transition-colors flex items-center justify-center gap-2"
            >
              <FaPlus /> {editIndex !== null ? "Actualizar" : "Agregar"}
            </button>
          </div>
        </>
      )}
      {/* Tabla de filas agregadas */}
      {rows.length > 0 && (
        <div className="w-full overflow-x-auto mt-4">
          <table className="min-w-full text-sm text-gray-700">
            <thead className="bg-color-secundario text-white">
              <tr>
                {fields.map((f) => (
                  <th
                    key={f.name}
                    className={`px-3 py-2 font-semibold whitespace-nowrap ${f.type === 'number' ? 'text-right' : 'text-left'}`}
                  >
                    {f.placeholder || f.name || f.label}
                  </th>
                ))}
                <th className="w-12"></th>
                <th className="w-12"></th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, rowIndex) => (
                <tr key={rowIndex} className="border-b border-gray-200">
                  {fields.map((f, colIndex) => (
                    <td
                      key={`${rowIndex}-${f.name}`}
                      className={`px-3 py-3 whitespace-nowrap 
        ${f.type === 'number' ? 'text-right' : ''}
        ${f.name === "anulado_detalle" && row[f.name] == true ? "text-red-500 font-semibold" : ""}`}
                    >
                      {f.type === "select" && Array.isArray(f.options)
                        ? (() => {
                            // Buscar en las opciones actuales
                            const option = f.options.find(
                              (opt) =>
                                String(opt.value) === String(row[f.name]),
                            );

                            // Si no se encuentra en las opciones actuales, buscar en valores previos correctamente
                            if (option) return option.label;

                            // Buscar en valores previos según el campo (provincia/municipio)
                            if (f.name === "id_provincia") {
                              const prevOption =
                                valoresPrevios.provincias?.find(
                                  (opt) =>
                                    String(opt.value) === String(row[f.name]),
                                );
                              return prevOption
                                ? prevOption.label
                                : row[f.name];
                            }

                            if (f.name === "id_municipio") {
                              const prevOption =
                                valoresPrevios.municipios?.find(
                                  (opt) =>
                                    String(opt.value) === String(row[f.name]),
                                );
                              return prevOption
                                ? prevOption.label
                                : row[f.name];
                            }

                            return row[f.name]; // Si no encuentra nada, muestra el value
                          })()
                        : f.type === "producto"
                          ? (() => {
                              const nombre = nombresProductos.find(
                                (opt) =>
                                  String(opt.value) === String(row[f.name]),
                              );
                              return (nombre && nombre.label) || row[f.name];
                            })()
                          : f.name == "costo" || f.name == "monto"
                            ? formatoMoneda(row[f.name])
                            : f.name == "anulado_detalle"
                              ? row[f.name] == true
                                ? "Si"
                                : "No"
                              : f.type == "retencion"
                                ? (() => {
                                    const nombre = nombresRetenciones.find(
                                      (opt) =>
                                        String(opt.value) ===
                                        String(row[f.name]),
                                    );
                                    return (
                                      (nombre && nombre.label) || row[f.name]
                                    );
                                  })()
                                : row[f.name]}
                    </td>
                  ))}
                  {(editable || row.AgregarSinModificar) && (
                    <>
                      <td className="px-3 py-3 text-center">
                        <button
                          type="button"
                          onClick={() => handleEditRow(rowIndex)}
                          className="text-color-secundario"
                          key={`edit-button-${rowIndex}`}
                        >
                          <FaEdit />
                        </button>
                      </td>
                      <td className="px-3 py-3 text-center">
                        <button
                          type="button"
                          onClick={() => handleRemoveRow(rowIndex)}
                          className="text-color-secundario"
                          key={`remove-button-${rowIndex}`}
                        >
                          <FaTrash />
                        </button>
                      </td>
                    </>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <hr className="mt-6 border-t border-gray-200" />
      <PlantillaModal
        mostrar={mostrarModalProducto}
        onClose={() => setMostrarModalProducto(false)}
      >
        <TablaProducto
          setProductoSeleccionado={(e) => handleSeleccionarProducto(e)}
          tipo_producto={tipo_producto}
          tipo_tabla={tipo_tabla_producto}
          id_sucursal={id_sucursal_tabla_producto}
        />
      </PlantillaModal>

      <PlantillaModal
        mostrar={mostrarModalRetencion}
        onClose={() => setMostrarModalRetencion(false)}
      >
        <TablaRetencion
          setRetencionSeleccionada={(e) => handleSeleccionarRetencion(e)}
        />
      </PlantillaModal>
    </div>
  );
};

export default TablaDinamica;
